import * as constants from '../constants/CONSTANT';

async function requestJson(url, options = {}) {
  const token = localStorage.getItem('token');
  const response = await fetch(url, {
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
      ...(options.headers || {}),
    },
    ...options,
  });
  return response.json();
}

const AiSchemaApi = {
  async listCatalog() {
    return requestJson(constants.API_BASE_URL + '/api/objectconfig/ai-schema/catalog', {
      method: 'GET',
    });
  },

  async saveCatalogBatch(items) {
    return requestJson(constants.API_BASE_URL + '/api/objectconfig/ai-schema/catalog', {
      method: 'PUT',
      body: JSON.stringify({ items }),
    });
  },

  async listStandardCatalog() {
    return requestJson(constants.API_BASE_URL + '/api/objectconfig/ai-schema/standard/catalog', {
      method: 'GET',
    });
  },

  async saveStandardCatalogBatch(items) {
    return requestJson(constants.API_BASE_URL + '/api/objectconfig/ai-schema/standard/catalog', {
      method: 'PUT',
      body: JSON.stringify({ items }),
    });
  },

  async saveObject(objectName, payload) {
    return requestJson(
      constants.API_BASE_URL + `/api/objectconfig/ai-schema/objects/${encodeURIComponent(objectName)}`,
      {
        method: 'PUT',
        body: JSON.stringify(payload),
      }
    );
  },

  async syncFields(objectName) {
    return requestJson(
      constants.API_BASE_URL + `/api/objectconfig/ai-schema/objects/${encodeURIComponent(objectName)}/sync-fields`,
      {
        method: 'POST',
        body: JSON.stringify({}),
      }
    );
  },
};

export default AiSchemaApi;
